"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _createPublicI18nProvider = _interopRequireDefault(require("I18n/init/providers/createPublicI18nProvider"));

var _AppInit = require("I18n/init/setup/AppInit");

var _registerAllData = _interopRequireDefault(require("I18n/init/register/lazy/registerAllData"));

var _en = _interopRequireDefault(require("i2l?query=sporks!../lang/en.lyaml"));

var _en2 = _interopRequireDefault(require("i2l?query=sporks!timezone-utils/lang/en.lyaml"));

require("I18n/init/data/allTimezones");

var _connectI18nLoader = _interopRequireDefault(require("./connectI18nLoader"));

var _reactRhumb = require("react-rhumb");

var _staticAdapter = _interopRequireDefault(require("react-rhumb/staticAdapter"));

var _rhumbConfig = _interopRequireDefault(require("../rhumb-config.yaml"));

var _hubspotUrlinator = _interopRequireDefault(require("hubspot.urlinator.Url"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _url = require("MeetingsBase/utils/url");

var _urlParams = require("MeetingsPublic/utils/urlParams");

var _createBookingComponent = _interopRequireDefault(require("MeetingsLib/components/createBookingComponent"));

var _pick = _interopRequireDefault(require("transmute/pick"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var _keySeq = _interopRequireDefault(require("transmute/keySeq"));

var _compose = _interopRequireDefault(require("transmute/compose"));

var _errorUtils = require("MeetingsLib/utils/errorUtils");

var _Raven = _interopRequireDefault(require("Raven"));

//I18n Configuration
var DatePickerMarker = function DatePickerMarker() {
  return _react.default.createElement(_reactRhumb.NavMarker, {
    name: "DATE_PICKER_BUTTON_LOAD"
  });
};

var TimePickerMarker = function TimePickerMarker() {
  return _react.default.createElement(_reactRhumb.NavMarker, {
    name: "TIME_PICKER_LOAD"
  });
};

var NotFoundMarker = function NotFoundMarker() {
  return _react.default.createElement(_reactRhumb.NavMarker, {
    name: "LINK_NOT_FOUND"
  });
};

var ErrorMarker = function ErrorMarker() {
  return _react.default.createElement(_reactRhumb.NavMarker, {
    name: "BOOKING_LOAD_FAILURE"
  });
};

var EmailFormMarker = function EmailFormMarker() {
  return _react.default.createElement(_reactRhumb.NavMarker, {
    name: "EMAIL_FORM_LOAD"
  });
};

var Application = /*#__PURE__*/function () {
  function Application() {
    (0, _classCallCheck2.default)(this, Application);
  }

  (0, _createClass2.default)(Application, [{
    key: "init",
    value: function init() {
      var _this = this;

      if (window.newrelic && window.performance && window.performance.getEntriesByName) {
        var scriptStartEntries = window.performance.getEntriesByName('scriptStartTime');

        if (scriptStartEntries && scriptStartEntries.length > 0) {
          window.newrelic.setCustomAttribute('scriptStartTime', scriptStartEntries[0].startTime);
          window.newrelic.setCustomAttribute('appStartTime', window.performance.now());
        }
      }

      _Raven.default.setDataCallback(_errorUtils.ravenDataCallback);

      var I18nProvider = (0, _createPublicI18nProvider.default)();
      var langAvailable = (0, _AppInit.initAppTranslations)([I18nProvider.register(_en.default), I18nProvider.register(_en2.default), (0, _registerAllData.default)(I18nProvider)]);
      langAvailable.then(function () {
        return _this.launch();
      });
    }
  }, {
    key: "launch",
    value: function launch() {
      var url = new _hubspotUrlinator.default(window.location);
      var slug = (0, _url.getSlug)(window.location.href);
      var embedded = url.paramValue('embed') === 'true';
      var forceOffline = url.paramValue('forceOffline') === 'true';
      var troubleshooting = url.paramValue('troubleshoot') === 'true';
      var urlParams = (0, _urlParams.mapFalsyParamsToNull)(url);
      var trackingParams = (0, _pick.default)(['utm_campaign', 'utm_source', 'utm_medium', 'meeting_funnel', 'meeting_product', 'meeting_medium', 'meeting_type', 'meeting_source', 'meeting_campaign', 'source_app'], urlParams);
      var forcePropertyForm;

      try {
        forcePropertyForm = JSON.parse(url.paramValue('forcePropertyForm'));
      } catch (e) {
        forcePropertyForm = null;
      }

      var parentPageHSAnalyticsInfo = (0, _pick.default)(['parentPageUrl', 'parentHubspotUtk'], urlParams);
      var formFieldUrlParams = (0, _omit.default)((0, _keySeq.default)(parentPageHSAnalyticsInfo), (0, _omit.default)((0, _keySeq.default)(trackingParams), urlParams));
      var formState = (0, _urlParams.constructFormState)(formFieldUrlParams);

      if (window.quickFetch && window.newrelic) {
        var requestState = window.quickFetch.getRequestStateByName('book-info');
        var bookInfoFetchPreRender = !!(requestState && requestState.finished && !requestState.errored);
        window.newrelic.setCustomAttribute('bookInfoFetchPreRender', bookInfoFetchPreRender);
      }

      if (window.performance && window.performance.mark) {
        window.performance.mark('create-booking-component');
      }

      var BookingComponent = (0, _createBookingComponent.default)({
        httpClient: _noAuthApiClient.default,
        slug: slug,
        embedded: embedded,
        forceOffline: forceOffline,
        troubleshooting: troubleshooting,
        forcePropertyForm: forcePropertyForm,
        trackingParams: trackingParams,
        formState: formState,
        parentPageHSAnalyticsInfo: parentPageHSAnalyticsInfo,
        allowTroubleshootMode: true,
        allowRedirect: true
      });
      var WrappedComponent = (0, _compose.default)(_connectI18nLoader.default)(BookingComponent);
      var appRoute = document.getElementsByClassName('page')[0];
      window.disabledHsPopups = ['LEADFLOW', 'FEEDBACK'];

      if (embedded) {
        appRoute.className += ' embedded'; // set disabled popups so that scripts don't load twice
        // (once on parent page and once in iframe) on embedded meetings

        window.disabledHsPopups.push('PRIVACY', 'ADS', 'LIVE_CHAT'); // set __hsUserToken as utk passed in from parent page so
        // analytics tracker will init with consistent utk across iframe and parent
        // otherwise, we have form submission and view with incorrect source

        window.__hsUserToken = urlParams.parentHubspotUtk;
      }

      _reactDom.default.render(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactRhumb.RhumbProvider, {
        history: (0, _staticAdapter.default)('/'),
        config: _rhumbConfig.default
      }, _react.default.createElement(WrappedComponent, {
        hideLogo: embedded,
        DatePickerMarker: DatePickerMarker,
        TimePickerMarker: TimePickerMarker,
        NotFoundMarker: NotFoundMarker,
        ErrorMarker: ErrorMarker,
        EmailFormMarker: EmailFormMarker
      }))), appRoute);
    }
  }]);
  return Application;
}();

exports.default = Application;
module.exports = exports.default;